import { MonitorSmartphone } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";

export const MobileBlocked = () => {
  const { user, workspace, logout, refresh } = useAuth();
  const navigate = useNavigate();
  return (
    <div className="tc-login tc-blocked" data-testid="mobile-blocked">
      <div className="tc-login__logo"><span className="tc-login__mark">TC</span><span className="tc-login__wordmark">Total Chat</span></div>
      <div className="tc-blocked__card">
        <MonitorSmartphone size={40} />
        <h1>Mobile access is turned off for your account</h1>
        <p>{workspace?.name || "Your workspace"} only allows some members to use Total Chat on phones and tablets. Open it on a desktop computer, or ask a workspace admin to enable mobile access for <b>{user?.display_name}</b>.</p>
        <div className="tc-blocked__actions">
          <button className="tc-btn tc-btn--outline" onClick={() => refresh()} data-testid="mobile-blocked-retry">Check again</button>
          <button className="tc-btn tc-btn--primary" onClick={() => { logout(); navigate("/login"); }} data-testid="mobile-blocked-signout">Sign out</button>
        </div>
      </div>
    </div>
  );
};
